import { RefreshToken } from '../../helper/api';
import { get_refreshToken } from '../../helper/UserData/userdate';
import { httpCustomer } from './axios';

 const queryString = require('query-string');

export class ServicesApi {

 

  async ServicePoints(params , refreshToken) {
    try {

      const response = await httpCustomer.request({
        method: 'get',
        url: '/api/v1/customer/service-points',
        params: params,
        headers : refreshToken &&{
              Authorization: "Bearer " + refreshToken,
          
        }
      });

      return response.data.data

    } catch (error) {
 
         if (error.response) {
           if (error.response.status === 401 && error.response.data.code == "-9") {
             RefreshToken(() => {
              this.ServicePoints(params , get_refreshToken());
             });
             //token exchange
           }
         }
     }


  }


}





